import React, {useEffect} from 'react';
import styles from '../../HeaderContainer.module.scss'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faGear} from "@fortawesome/pro-light-svg-icons";
import {faGear as faCogSolid} from "@fortawesome/pro-solid-svg-icons";
import NotificationAccordion from "../../../NavigationBarContainer/components/NotificationAccordion/NotificationAccordion";
import {
    useUserNotificationsSelector,
    useNotificationLimitSelector, useProjectMemberSelector,
} from "../../../../../../store/selectors/team.selectors";
import {UserNotificationModel} from "../../../../../../models/responses/message.model";
import NotificationItem from "./component/NotificationItem";
import FirebaseUsage from "../../../../../../firebase/firebase.usage";
import {COLLECTIONS} from "../../../../../../firebase/constants";
import {subsManager} from "../../../../../../store/middleware/subs-manager/subs-manager";
import * as teamActions from "../../../../../../store/actions/team.actions";
import {useDispatch} from "react-redux";
import {useUserSelector} from "../../../../../../store/selectors/authorization.selectors";
import {useActiveProjectSelector} from "../../../../../../store/selectors/project.selectors";

export default function NotificationCentre(props: any) {
    const notifications = useUserNotificationsSelector();
    const notificationLimit = useNotificationLimitSelector();
    const user = useUserSelector();
    const activeProject = useActiveProjectSelector();
    const dispatch = useDispatch();
    const [showSettings, setShowSettings] = React.useState(false);
    const projectMember = useProjectMemberSelector();

    useEffect(() => {
        let readNotificationCount = 0;
        notifications.forEach((notification: UserNotificationModel) => {
            if (!notification.seen) {
                readNotificationCount++;
            }
        })
        if (readNotificationCount > 0 && projectMember && projectMember.unreadNotifications) {
            FirebaseUsage.updateDoc(COLLECTIONS.PROJECT_MEMBERS, projectMember!.memberId, {
                unreadNotifications: Math.max(0, projectMember!.unreadNotifications - readNotificationCount)
            })
        }
        notifications.forEach((notification: UserNotificationModel) => {
            if (!notification.seen) {
                FirebaseUsage.updateDoc(COLLECTIONS.USER_NOTIFICATIONS, notification.uuid!, {
                    seen: FirebaseUsage.timestamp()
                })
            }
        })
    }, [notifications]);

    const loadMoreNotifications = () => {
        subsManager.removeSubscription('user-notifications')
        dispatch(teamActions.Actions.setUserNotificationsLimit(notificationLimit + 5))
        subsManager.subscribeUserNotifications(user!.userId!, activeProject ?
            activeProject.contractId ? activeProject.contractId :
                null : null, notificationLimit)
    }

    return (
        <div className={styles.NotificationContainer}>
            <div className={styles.NotificationHeader}>
                <strong>Notifications</strong>
                <FontAwesomeIcon
                    className={styles.NotificationSettingsIcon}
                    icon={showSettings ? faCogSolid : faGear}
                                 onClick={() => setShowSettings(!showSettings)}
                                 size="lg" />
            </div>
            {showSettings ? <div className={styles.NotificationSettings}>
                <NotificationAccordion isActive={showSettings} />
            </div> :
            <div id={'notification-list'} className={styles.NotificationList}
                 onScroll={(e) => {
                     if (e.currentTarget.scrollTop + e.currentTarget.clientHeight >= e.currentTarget.scrollHeight - 10) {
                         // console.log('Scrolled to bottom');
                         // Load more notifications here
                         loadMoreNotifications();
                     }
                 }}>
                {notifications
                    .slice(0, notificationLimit)
                    .map((notification: UserNotificationModel, index) => (
                    <NotificationItem notification={notification} key={index} />
                ))}
            </div>}
        </div>
    )
}

